<template>
  <div class="container-fluid">
    <panel
      Title="مدیریت محتواها "
      Des="در این بخش میتوانید فرم ها و محتواهای خود را برای دانلود کاربران مدیریت کنید"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>

    <net-pa-card>
      <template slot="header">
        <h6 class="text-right"><i class="fas fa-file"></i> مدیریت فایلها</h6>
      </template>

      <template slot="content">
        <div class="bnp-files-manage">
          <!-- لیست فایل‌ها -->
          <section class="bnp-files-manage__list" aria-labelledby="files-list-title">
            <header class="bnp-section-head">
              <span class="bnp-section-head__icon" aria-hidden="true">
                <i class="fas fa-folder-open"></i>
              </span>
              <div>
                <h6 id="files-list-title" class="bnp-section-head__title">
                  لیست فایل‌ها
                </h6>
                <p class="bnp-section-head__desc">
                  فایل‌هایی که کاربران می‌توانند دریافت کنند.
                </p>
              </div>
            </header>

            <files-list :key="RenderFilesList" IsAdmin="true"></files-list>
          </section>

          <!-- افزودن فایل -->
          <aside class="bnp-files-manage__upload" aria-labelledby="files-upload-title">
            <header class="bnp-section-head">
              <span class="bnp-section-head__icon" aria-hidden="true">
                <i class="fas fa-cloud-upload-alt"></i>
              </span>
              <div>
                <h6 id="files-upload-title" class="bnp-section-head__title">
                  افزودن فایل جدید
                </h6>
                <p class="bnp-section-head__desc">
                  فرمت‌های مجاز: PDF، تصویر، ZIP و RAR — حداکثر ۵ مگابایت
                </p>
              </div>
            </header>

            <div class="bnp-upload-box">
              <uploader
                :whithName="true"
                :Idu="'FormFile'"
                :key="keyrender"
                :base64="null"
                :TableName="'ExtraForms'"
                @Done="GetFile"
                :attachId="null"
                :address="null"
                :grp="attachGrp"
                :title="'فایل خود را بارگذاری کنید'"
                :MasterId="$session.get('CustCode')"
              >
                <template slot="uploaderCombo">
                  <label for="FileGroup" class="bnp-upload-box__label">
                    دسته‌بندی فایل
                  </label>
                  <select
                    id="FileGroup"
                    class="form-control bnp-upload-box__select"
                    v-model="attachGrp"
                  >
                    <option value="181070513">فرم های جانبی</option>
                    <option value="100" v-if="hasEmza">
                      قرارداد عضویت (برای امضا)
                    </option>
                    <option value="101" v-if="hasEmza">
                      قرارداد وام (برای امضا)
                    </option>
                  </select>
                </template>
              </uploader>
            </div>
          </aside>
        </div>
      </template>
    </net-pa-card>
  </div>
</template>

<script>
import NetPaCard from "../../Tools/NetPa/NetPaCard.vue";
import Panel from "../../Tools/NetPa/Panel.vue";
import uploader from "../Componenets/NetpaUploader.vue";
import FilesList from "./FilesList.vue";

export default {
  components: { Panel, NetPaCard, uploader, FilesList },
  data() {
    return {
      keyrender: 0,
      RenderFilesList: 0,
      hasEmza: false,
      attachGrp: 181070513,
    };
  },
  methods: {
    // بعد از هر آپلود، لیست فایل‌ها دوباره بارگذاری می‌شود
    GetFile() {
      this.RenderFilesList++;
    },
  },
  mounted() {
    // FilesList خودش هنگام ساخته‌شدن داده را می‌گیرد؛ نیازی به بارگذاری مجدد نیست
    this.hasEmza = this.$GetHasEmza();
  },
};
</script>

<style scoped>
.bnp-files-manage {
  --bnp-brand-navy: #29345f;
  --bnp-brand-indigo: #56508d;
  --bnp-text-primary: #13243a;
  --bnp-text-secondary: #6b7b8e;
  --bnp-surface-subtle: #f9fbfc;
  --bnp-surface-accent: #edf7fb;
  --bnp-border-default: #dbe5eb;
  --bnp-border-subtle: #e8eef2;
  --bnp-focus-color: #05b8c8;
  --bnp-focus-ring: 0 0 0 4px rgba(5, 184, 200, 0.2);
  --bnp-radius-md: 14px;
  --bnp-radius-lg: 20px;

  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 24px;
  align-items: start;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  color: var(--bnp-text-primary);
  text-align: right;
}

.bnp-files-manage__list,
.bnp-files-manage__upload {
  min-width: 0;
}

.bnp-files-manage__upload {
  padding: 16px;
  border: 1px solid var(--bnp-border-subtle);
  border-radius: var(--bnp-radius-lg);
  background: var(--bnp-surface-subtle);
}

/* سرتیتر هر بخش */
.bnp-section-head {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--bnp-border-subtle);
}

.bnp-section-head__icon {
  display: inline-grid;
  flex: 0 0 38px;
  width: 38px;
  height: 38px;
  color: var(--bnp-brand-indigo);
  font-size: 15px;
  place-items: center;
  border-radius: 12px;
  background: var(--bnp-surface-accent);
}

.bnp-section-head__title {
  margin: 0;
  color: var(--bnp-brand-navy);
  font-size: 15px;
  font-weight: 800;
  line-height: 1.7;
}

.bnp-section-head__desc {
  margin: 0;
  color: var(--bnp-text-secondary);
  font-size: 12px;
  line-height: 1.8;
}

/* باکس بارگذاری */
.bnp-upload-box {
  max-width: 360px;
  margin: 0 auto;
  padding: 12px;
  border: 1px dashed var(--bnp-border-default);
  border-radius: var(--bnp-radius-md);
  background: #fff;
}

.bnp-upload-box >>> .container-fluid {
  padding: 0;
}

.bnp-upload-box >>> img {
  display: block;
  max-width: 200px;
  margin: 0 auto;
}

.bnp-upload-box >>> input.form-control,
.bnp-upload-box__select {
  height: 42px;
  font-family: inherit;
  font-size: 12px !important;
  border-color: var(--bnp-border-default);
  border-radius: 12px;
}

.bnp-upload-box >>> input.form-control:focus,
.bnp-upload-box__select:focus {
  border-color: var(--bnp-focus-color);
  box-shadow: var(--bnp-focus-ring);
}

.bnp-upload-box__label {
  display: block;
  margin: 12px 0 4px;
  color: var(--bnp-text-secondary);
  font-size: 12px;
  font-weight: 700;
}

.bnp-upload-box >>> .btn-primary {
  height: 42px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  border: 0;
  border-radius: 12px;
  background: linear-gradient(110deg, #29345f, #56508d 58%, #8d58a4);
}

@media (min-width: 992px) {
  .bnp-files-manage {
    /* لیست در سمت راست (RTL)، آپلود در سمت چپ */
    grid-template-columns: minmax(0, 1fr) 340px;
  }

  .bnp-files-manage__upload {
    position: sticky;
    top: 16px;
  }
}

/* ستون لیست باریک‌تر شده؛ تا عرض‌های بزرگ کارت‌ها تک‌ستونه بمانند */
@media (min-width: 992px) and (max-width: 1399px) {
  .bnp-files-manage__list >>> .bnp-file-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (max-width: 575px) {
  .bnp-files-manage__upload {
    padding: 12px;
  }
}
</style>
